
import React from "react";
import { useTranslation } from "react-i18next";
import { Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import {
  FaVoteYea,
  FaMapMarkedAlt,
  FaUsers,
  FaUserTie,
  FaFileAlt,
  FaCalendarPlus,
  FaAddressCard,
  FaUserPlus,
  FaUsersCog,
  FaHandsHelping,
  FaUserFriends,
} from "react-icons/fa";

const cardData = [
  { key: "election", icon: <FaVoteYea />, route: "/election", desc: "Configure and manage election details." },
  { key: "state", icon: <FaMapMarkedAlt />, route: "/state", desc: "Add and manage states in the system." },
  { key: "district", icon: <FaMapMarkedAlt />, route: "/district", desc: "Handle district-level configurations." },
  { key: "division", icon: <FaMapMarkedAlt />, route: "/division", desc: "Organize divisions under districts." },
  { key: "addPrabhaag", icon: <FaAddressCard />, route: "/add-prabhaag", desc: "Create and update prabhaag records." },
  { key: "addPosition", icon: <FaUserTie />, route: "/add-position", desc: "Define roles and positions." },
  { key: "addCategory", icon: <FaFileAlt />, route: "/add-category", desc: "Maintain member and voter categories." },
  { key: "addMember", icon: <FaUsers />, route: "/add-member", desc: "Register new members in the party." },
  { key: "candidate", icon: <FaUserFriends />, route: "/candidate", desc: "Manage candidate profiles and info." },
  { key: "addLocalMember", icon: <FaUsersCog />, route: "/add-local-member", desc: "Handle local-level memberships." },
  { key: "addElectors", icon: <FaHandsHelping />, route: "/add-electors", desc: "Add and manage elector data." },
  { key: "Add Users", icon: <FaUserPlus />, route: "/users", desc: "Create system users and admins." },
  { key: "Meeting", icon: <FaCalendarPlus />, route: "/meetings", desc: "Schedule and manage meetings." },
];

const SuperAdminDashboard = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="container-fluid my-5">
      <section className="section-admin-dashboard py-0">
        <div className="marginpadding">
          <Row className="align-items-start py-5 px-3 mx-3">
            {/* Left column: text (full width on mobile, 3/12 on xl) */}
            <Col xl={3} lg={4} md={12} className="mb-4">
              <div className="section-header">
                <h2>{t("superAdmin")}</h2>
                <p>
                  Manage all administrative functions, user accounts, and system
                  configurations from one centralized dashboard.
                </p>
                {/* <button
                  className="view-button"
                  onClick={() => {
                    window.scrollTo(0, 0);
                  }}
                >
                  View Dashboard Guide
                </button> */}
              </div>
            </Col>

            {/* Right column: responsive cards grid */}
            <Col xl={9} lg={8} md={12}>
              <div
                style={{
                  display: "grid",
                  gap: "40px",
                  marginLeft: "50px",
                  marginRight: "50px",
                  paddingLeft: "20px",
                  paddingRight: "20px",
                  
                  // min 160px per card, auto number of columns based on width
                  gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))",
                }}
              >
                {cardData.map(({ key, icon, route, desc }) => (
                  <div
                    key={key}
                    style={cardStyle}
                    onClick={() => navigate(route)}
                    role="button"
                    tabIndex={0}
                    onKeyPress={(e) => {
                      if (e.key === "Enter" || e.key === " ") navigate(route);
                    }}
                  >
                    <div style={iconStyle}>{icon}</div>
                    <div style={titleStyle}>{t(key)}</div>
                    <p style={descStyle}>{desc}</p>
                  </div>
                ))}
              </div>
            </Col>
          </Row>
        </div>
      </section>
    </div>
  );
};

// Cards styles (slightly relaxed sizes for mobile)
const cardStyle = {
  borderRadius: "10px",
  boxShadow: "0 1px 4px rgba(0,0,0,0.1)",
  background: "#fff",
  border: "1px solid #e0e0e0",
  display: "flex",
  flexDirection: "column",
  cursor: "pointer",
  transition: "all 0.3s ease",
  padding: "16px 8px",
  textAlign: "center",
  minHeight: "140px",
  justifyContent: "center",
  alignItems: "center",
  gap: "8px",
};

const iconStyle = {
  fontSize: "2.5rem",
  color: "#FD7E14",
  marginBottom: "6px",
};

const titleStyle = {
  fontWeight: "bold",
  fontSize: "0.9rem",
  color: "#333",
  marginBottom: "4px",
};

const descStyle = {
  fontSize: "0.75rem",
  color: "#666",
  margin: 0,
};

export default SuperAdminDashboard;
